import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/logozi1.png";
import contact from './Contacts'
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 300);
  const [index, setIndex] = useState(1);
  const toRotate = ["Java FullStack", "WebApp Dev", "Front-End Dev"];
  const period = 500;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text])

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta * 0.250); // Smoother deletion
    } else {
      // Gradually decrease delta during insertion as well
      setDelta(prevDelta => prevDelta * 0.250);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(300);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  }

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <span className="tagline">Welcome to my Portfolio</span>
                  <h1>
  {`Hi! I'm Kajol`}{" "}
  <span
  className="txt-rotate animate__animated animate__fadeIn" // Add CSS animation class
  dataPeriod="300"
  data-rotate='[ "Java FullStack", "Web Developer", "Front-End Dev", "Software Tester" ]'
>
  <span className="wrap">{text}</span>
</span>
</h1>
                  <p>Aspiring software developer with a
                    passion for coding and problem-solving,
                    seeking a challenging role to apply my
                    technical skills and contribute to the
                    development of innovative software
                    solutions. Versatile Java Developer
                    creative web app builder, skilled
                    presenter, and growing interest in Software Testing.</p>
                  {/* <button onClick={() => contact}>Let’s Connect <ArrowRightCircle size={25} onClick={contact} /></button> */}
                </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img" />
                </div>}
            </TrackVisibility>
          </Col>
         
        </Row>
      </Container>
    </section>
  )
}
export default Banner;